<template>
  <div class="product-list">

    <v-container grid-list-xl fluid>
      <v-layout row wrap>
        <v-flex sm12>
          <h1><v-icon large>mdi-purse</v-icon>{{$t('qualitycheck.product.products')}}</h1>
        </v-flex>
        <v-flex lg12>

          <v-data-table
            v-model="selected"
            :headers="headers"
            :items="items"
  :items-per-page.sync="options.itemsPerPage"
:footer-props="footer"
            :loading="isLoading"
            :loading-text="$t('global.loading')"
            :options.sync="options"
            :server-items-length="totalItems"
            class="elevation-1"
            item-key="@id"
            @update:options="onUpdateOptions"
            @click:row="showHandlerSub"
@contextmenu:row="showHandlerSubExt"
          >

                <template slot="item.customerLoan" slot-scope="{ item }">
                  <span v-if="item.customerLoan" class="mr-2"><v-icon color="white">mdi-check-circle</v-icon></span>
               <!--  <span v-else class="mr-2"><v-icon color="red">mdi-close-circle</v-icon></span>--> 

                </template>
            <ActionCell
              slot="item.action"
              slot-scope="props"
              :handle-show="() => showHandlerSub(item,'Product',props.item)"
            ></ActionCell>
          </v-data-table>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import ListMixin from '../../mixins/ListMixin';
import AccessMixin from '../../mixins/AccessMixin';

export default {
  name: 'ProductListCustomer',
  servicePrefix: 'ProdFile',
  mixins: [ListMixin,AccessMixin],
  components: {

  },
  props: {
    customerParent: {
      type: Object,
      required: true
    },
  },
  data() {
    return {
      headers: [
        { text: this.$t('qualitycheck.product.name'), value: 'name' },
        { text: this.$t('qualitycheck.product.statu'), value: 'status.name' },
        { text: this.$t('qualitycheck.product.location'), value: 'location' },
        { text: this.$t('qualitycheck.product.type'), value: 'type' },
        { text: this.$t('qualitycheck.product.customerloan'), value: 'customerLoan' },

      ],
      filters: {
        'customer' : this.customerParent['@id'],
        'customerLoan' : this.customerParent['@id'],
      },
      selected: []
    };
  },
  computed: {
    ...mapGetters('product', {
      items: 'list'
    }),
    ...mapFields('product', {
      deletedItem: 'deleted',
      error: 'error',
      isLoading: 'isLoading',
      resetList: 'resetList',
      totalItems: 'totalItems',
      view: 'view'
    })
  },
  methods: {
    ...mapActions('product', {
      getPage: 'fetchAll',
      deleteItem: 'del'
    })
  }
};
</script>
